import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import Navbar from './NavbarStory';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Calling from '../../api/Calling';
import { FaArrowLeft, FaArrowRight, FaTrash } from 'react-icons/fa';
import { FaRegCirclePlay } from 'react-icons/fa6';
import generateCaptcha from '../../components/captcha';
import { formatView } from '../../components/formatView';
import { MdDeleteSweep } from 'react-icons/md';
import { videoSizeExceededMessage, MAX_FILE_SIZE_VIDEO } from '../../components/imageType'; // Import the allowed image types
import ActionButton from '../../components/ul/ActionButton';
import UploadButton from '../../components/ul/UploadButton';
import FileUpload from '../../components/ul/FileUpload';
import { LuDot } from 'react-icons/lu';
import ResetButton from '../../components/ul/ResetButton';
import NotFound from '../../components/ul/NotFound';
import DeleteButton from '../../components/ul/DeleteButton';
import ClickView from '../../components/ul/ClickView';

const Reels = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [selectRecord, setSetectRecord] = useState([]);
    const [reelsStatus, setReelsStatus] = useState(false);
    const [file, setFile] = useState(null);

    const [page, setPage] = useState(1);
    const [limit] = useState(20);
    const [fileProcessing, setFileProcessing] = useState({
        image: false,
        video: false,
    });
    const [fileStatus, setFileStatus] = useState({
        image: null, // 'success', 'error', or null
        video: null,
    });
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [page])


    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoader(true)
        try {
            const resp = await Calling.getReels(page, limit);
            if (resp?.status) {
                setTableData(resp?.data || []);
                setTotalPages(resp?.totalPage || 1);
                setReelsStatus(resp?.reels);
            } else {
                toast.error('Data Not Fetch')
            }
        } catch (error) {
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    }

    const reelType = [
        'video/mp4',
    ];

    const handleChangeFile = (e) => {
        const { name, files, id } = e.target;
        const validFiles = [];
        let hasError = false;

        if (files.length === 0) return;

        for (let file of files) {
            if (!reelType.includes(file.type)) {
                toast.error('Please select a valid video file. Allowed type: MP4');
                hasError = true;
                continue;
            }

            if (file.size > MAX_FILE_SIZE_VIDEO) {
                toast.error(videoSizeExceededMessage);
                hasError = true;
                continue;
            }
            validFiles.push(file);
        }

        if (validFiles.length > 0) {
            setFileProcessing(prevState => ({ ...prevState, [id]: true }));
            setFileStatus(prevState => ({ ...prevState, [id]: null }));

            // Simulate file processing
            setTimeout(() => {
                setFileProcessing(prevState => ({ ...prevState, [id]: false }));
                setFileStatus(prevState => ({ ...prevState, [id]: 'success' }));
            }, 1000);

            if (name === 'video') {
                setVideoFile(prevFiles => [...(prevFiles || []), ...validFiles]); // Store all selected files
            }
        }

        if (hasError) {
            e.target.value = ''; // Clear input if there were errors
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (videoFile?.length === 0) {
            toast.error("Please select a valid Type Video .");
            return;
        }
        try {
            setLoader(true);
            const formData = new FormData();

            videoFile.forEach((videoFile) => {
                formData.append('video', videoFile); // 'videos' should match your backend field name
            });

            const resp = await Calling.addReels(formData);
            if (resp?.status) {
                toast.success(resp?.message);
                await fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
            setVideoFile(null);
            setFileStatus({
                image: null, // 'success', 'error', or null
                video: null,
            });
            setFile(null)
        }
    }


    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };



    const handleselect = (recordId) => {
        setSetectRecord((prev) => selectRecord.includes(recordId) ? prev.filter(id => id !== recordId) : [...prev, recordId]);
    }

    const handleDeleteStory = async (id) => {
        setLoader(true);
        try {
            const content = `You are about to delete Story. To confirm, please solve this math problem`
            const check = generateCaptcha(content);
            if (check) {
                const body = {}
                if (!id) {
                    body.id = selectRecord;
                } else {
                    body.id = [id];
                }
                const response = await Calling.deleteReels(body);
                const { status, message } = response;
                if (status) {
                    toast.success(message, { autoClose: 2000 });
                    setSetectRecord([]);
                    await fetchData();
                } else {
                    toast.error(message, { autoClose: 2000 });
                }
            } else {
                toast.error("Ans in not currect", { autoClose: 2000 });
            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    }

    const handleReset = () => {
        setImageFile(null);
        setVideoFile(null);
        setFileStatus({
            image: null, // 'success', 'error', or null
            video: null,
        })
        setFile(null)
    }
    const handleViewAnalitic = (id) => {
        // navigate(`/views/dashboard/${id}`)
    }

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2">
                        <h1 className="text-xl sm:text-2xl font-bold">Story Management</h1>
                    </div>
                    <div className='bg-main-white rounded-xl'>
                        <Navbar selectState={'reels'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />

                        {/* <div className='p-6'>
                           
                            <hr className='border-main-border' />
                            <form onSubmit={handleSubmit} encType='multipul/form-data' className='space-y-4 mt-8'>
                                <div className='grid grid-cols-12 gap-2 items-center'>
                                    <div className='grid grid-cols-12 gap-2 items-center col-span-6'>
                                        <label className='col-span-2 text-main-font font-medium'>Video:</label>
                                        <div className='col-span-9 relative'>
                                            <FileUpload id="video" name='video' accept="video/mp4" onChange={handleChangeFile} required={true} multiple='true' />
                                            {fileProcessing['video'] && <div className='absolute inset-0 flex items-center justify-center'><div className='loader'></div></div>}
                                            {fileStatus['video'] === 'error' && <div className='absolute inset-0 flex text-red-500 ml-[-20px] text-xl mt-3'>✘</div>}
                                            {fileStatus['video'] === 'success' && <div className='absolute inset-0 flex ml-[-20px] text-xl mt-3 text-green-500'>✓</div>}
                                            <p className={` text-[12px] mt-1 ${fileStatus['video'] === 'error' ? 'text-main-delete' : 'text-main-subfont'}`}>Only Video MP4 files allowed.</p>

                                        </div>
                                    </div>
                                </div>

                                <div className='grid grid-cols-12 pt-4 gap-4'>
                                    <UploadButton className='w-full sm:w-auto' />
                                    <ResetButton className='w-full sm:w-auto' onClick={handleReset} />
                                </div>
                            </form>
                        </div> */}


                        {/* <hr className='mt-2 bg-main-border border-[2px]' /> */}

                        <div className='w-[100%] h-auto bg-main-white'>
                            <div className='flex justify-between items-center  my-5 px-4'>
                                <h1 className='text-2xl font-bold text-main-font'>Reels List</h1>
                                {reelsStatus ?
                                    <span className='px-4 py-1 text-sm rounded-full bg-green-100 text-green-600 flex items-center'><LuDot size={20} /> Running</span> :
                                    <span className='px-4 py-1 text-sm rounded-full bg-red-100 text-red-600 flex items-center'><LuDot size={20} /> Not Running</span>
                                }
                            </div>
                            <div className='overflow-x-auto'>
                                <table className='w-[100%] '>
                                    <thead className='bg-main-th text-main-font uppercase '>
                                        <tr>
                                            <th className='ps-6 py-3 text-left text-sm font-medium rounded-tl-lg'>
                                                <input type='checkbox' className='me-2' onChange={(e) => setSetectRecord(e.target.checked ? tableData.map(v => v._id) : [])} />
                                                {selectRecord.length > 0 && (
                                                    <DeleteButton
                                                        onClick={() => handleDeleteStory()} label={<MdDeleteSweep size={20} />} />
                                                )}
                                            </th>
                                            <th className='px-4 py-3 text-left text-sm font-medium'>No</th>
                                            <th className='px-4 py-3 text-left text-sm font-medium'>Reels</th>
                                            <th className='px-4 py-3 text-left text-sm font-medium'>View</th>
                                            <th className='px-4 py-3 text-left text-sm font-medium'>Like</th>
                                            <th className='px-4 py-3 text-left text-sm font-medium rounded-tr-lg'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200 bg-white'>
                                        {tableData.length > 0 ? (
                                            tableData.map((v, i) => (
                                                <tr key={i} className='hover:bg-main-thHover'>
                                                    <td className='ps-6 py-3'>
                                                        <input type='checkbox' checked={selectRecord.includes(v._id)} onChange={e => handleselect(v._id)} />
                                                    </td>
                                                    <td className='px-4 py-3'>{(limit * (page - 1)) + i + 1}</td>
                                                    <td className="px-4 py-3">
                                                        <video
                                                            src={v?.video}
                                                            className="w-20 h-20 rounded-md object-cover"
                                                            controls
                                                            muted
                                                        />
                                                    </td>
                                                    <td className="px-4 py-3"><ClickView label={formatView(v?.view)} onClick={() => handleViewAnalitic(v?._id)} /></td>
                                                    <td className="px-4 py-3"> <ClickView label={formatView(v?.click)} onClick={() => handleViewAnalitic(v?._id)} /></td>
                                                    <td className='px-4 py-3'>{<ActionButtons v={v} handleDeleteStory={handleDeleteStory} />}</td>
                                                </tr>
                                            ))
                                        ) : <tr><td className='' colSpan={10}><NotFound /></td></tr>}
                                    </tbody>
                                </table>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-12 p-4 sm:p-6 relative">
                                {/* Pagination Controls - Centered on mobile, Left-aligned on larger screens */}
                                <div className="col-span-1 sm:col-span-6 flex justify-center sm:justify-start mb-4 sm:mb-0">
                                    <div className="flex gap-3 sm:gap-6">
                                        <button
                                            className={`px-2 w-[90px] sm:w-[110px] flex items-center justify-center gap-1 sm:gap-2 py-1.5 sm:py-2 text-sm sm:text-base rounded-lg ${page === 1
                                                ? "bg-main-white border border-main-border text-main-subfont"
                                                : "bg-main-blue text-main-white"
                                                }`}
                                            onClick={() => handlePageChange(page - 1)}
                                            disabled={page === 1}
                                        >
                                            <FaArrowLeft /> Previous
                                        </button>
                                        <button
                                            className={`px-2 w-[90px] sm:w-[110px] flex items-center justify-center gap-1 sm:gap-2 py-1.5 sm:py-2 text-sm sm:text-base rounded-lg ${page === totalPages
                                                ? "bg-main-white border border-main-border text-main-subfont"
                                                : "bg-main-blue text-main-white"
                                                }`}
                                            onClick={() => handlePageChange(page + 1)}
                                            disabled={page === totalPages}
                                        >
                                            Next <FaArrowRight />
                                        </button>
                                    </div>
                                </div>

                                {/* Page Number Display - Centered on mobile, Right-aligned on larger screens */}
                                <div className="col-span-1 sm:col-span-6 flex justify-center sm:justify-end">
                                    <p className="text-main-subfont text-sm sm:text-base">
                                        <span className="border border-main-border text-main-font px-2 py-1 rounded-lg">
                                            {page < 10 ? `0${page}` : page}
                                        </span>{" "}
                                        of {totalPages < 10 ? `0${totalPages}` : totalPages}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Reels;

const ActionButtons = ({ v, handleDeleteStory, handleEdit }) => {
    const [showActions, setShowActions] = useState(false);

    const handleButtonClick = () => {
        setShowActions(!showActions);
    };
    return (
        <div className='relative inline-block'>
            <ActionButton onClick={handleButtonClick} />


            {showActions && (
                <div className='absolute left-0 mt-2 bg-main-white border border-main-border rounded shadow-lg z-10'>
                    <a
                        href={v?.video}
                        target="_blank"
                        rel="noopener noreferrer"
                        className='flex items-center px-4 py-2 text-primary-purple hover:bg-purple-100 w-full text-left'
                    >
                        <FaRegCirclePlay size={20} className='me-2' /> Play
                    </a>

                    <button
                        className='flex items-center px-4 py-2 text-red-600 hover:bg-red-100 w-full text-left'
                        onClick={() => handleDeleteStory(v?._id)}
                    >
                        <FaTrash className='mr-2' /> Delete
                    </button>
                </div>
            )}
        </div>
    )
}
